export default "__VITE_ASSET__B6k_zK1M__"